 <div class="drag-container small" ngDraggable [inBounds]="true" [handle]="DragItem" *ngIf="showPopup">
  <div class="table-drag" #DragItem></div>
  <div class="drag-wrap" >
    <div class="drag-header">
      <h4  class="drag-title">{{ title }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="pressCloseButton()">
              <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="drag-body">
      <ng-scrollbar class="scroll">
          <p [innerHtml]="message"></p>
      </ng-scrollbar>
    </div>
    <div class="float-right btn-wrap">
      <button type="button" (click)="pressCloseButton()" class="btn btn-cancel">{{ buttonName }}</button>
    </div>
  </div>
</div>